import { createApi } from "@reduxjs/toolkit/query/react";
import {
  createBaseQuery,
  createServerSideRequestOption,
  getBaseUrl,
} from "../config";

export const getCompanies = async (request: Request) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/company/my-companies`,
    request: request,
    method: "GET",
  });
};

export const companyApi = createApi({
  reducerPath: "companyApi",
  baseQuery: createBaseQuery("/company"),
  tagTypes: ["companyApis"],
  endpoints: (build) => ({
    loadCompanies: build.query<CompanyUser[], void>({
      query: () => ({
        url: `/my-companies`,
        method: "GET",
      }),
    }),
    editCompany: build.mutation<
      Company,
      { companyId: number; data: CompanyData }
    >({
      query: ({ companyId, data }) => ({
        url: `/${companyId}/edit`,
        method: "PUT",
        body: data,
      }),
    }),
    onboardCompany: build.mutation<Company, CompanyData>({
      query: (body) => ({
        url: "/onboarding",
        method: "POST",
        body,
      }),
    }),
  }),
});
